export const STRAPI_URL = 'https://cms.listendot.com';
